var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <div> <ui-select ng-model=\"vm.data\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ $select.selected }} </ui-select-match> <ui-select-choices repeat=\"item in vm.tags\" refresh=\"vm.refreshTags($select.search)\" refresh-delay=\"300\"> <div>{{ item }}</div> </ui-select-choices> </ui-select> </div> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaTagSelect/lbaTagSelect.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaTagSelect/lbaTagSelect.html
// module id = 426
// module chunks = 0